import vr from "./mr-vikas-rastogi.jpg"
import vm from "./VinodMohitkar.jpg"
import sm from "./Sachin-Mandavgane.png"
const patron =[
    { "img" :vr,
      "name": "Dr. Taruna Gautam, Vice Chancellor",
      "detail": "IILM University Greater Noida, UP "
    }
  ]
  export default patron;